import apiRequest from "../../helpers/apiRequest";

export default async () => {
    return await apiRequest({
        method: 'get',
        url: `accounts/plans`,
    })
}
